/* import __COLOCATED_TEMPLATE__ from './reason-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import type {
  Job,
  JobId,
} from 'embercom/components/reporting/automation/ai-insights/optimize/jobs';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

interface Signature {
  Args: {
    job: Job | undefined;
    reportState: ReportState;
    selectedJobId: JobId | undefined;
    onOpenSectionChange: (jobId: JobId) => void;
    taskSuggestions?: TaskSuggestion[];
    conversationCount: number;
    suggestionCount: number;
    disabled: boolean;
  };
}

export default class ReasonCard extends Component<Signature> {
  @action
  handleSectionChange(jobId: JobId) {
    if (jobId === this.args.selectedJobId) {
      return;
    }
    this.args.onOpenSectionChange?.(jobId);
  }

  get jobLabel() {
    return this.args.job?.label || '';
  }

  get jobDescription() {
    return this.args.job?.description || '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::ReasonCard': typeof ReasonCard;
    'reporting/automation/ai-insights/optimize/reason-card': typeof ReasonCard;
  }
}
